module.exports = __webpack_public_path__ + "static/template_wellness-d7cb42aa80b5f4708ace386d30aa57ea.png";